'use client'

import cn from 'classnames'
import { useTranslations } from 'next-intl'
import ArrowLeft from './arrow-left.svg'
import styles from './index.module.scss'

import { useBookingState, useBookingActionsCtx } from '../../state/booking.context'

export default function BackButton() {
  const t = useTranslations('booking')
  const state = useBookingState()

  const { trackHistory } = useBookingActionsCtx()

  const click = () => {
    trackHistory(state.stage ? state.stage - 1 : 1)
  }

  return (
    <button className={cn(styles.button)} onClick={click}>
      <ArrowLeft /> {t('back')}
    </button>
  )
}
